import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-data-side-nav',
  templateUrl: './data-side-nav.component.html',
  styleUrls: ['./data-side-nav.component.scss']
})
export class DataSideNavComponent implements OnInit {

  navItems = [
    { title: 'PRO', link: '/data/pro/import-details', selected: false },
    { title: 'PARTNERS', link: '/data/partners/lists/partners-list', selected: false  },
    { title: 'SHOW MANAGEMENT', link: '/data/management', selected: false  },
    { title: 'IMPORT MANAGEMENT', link: '/data/import-management', selected: false  },

    //Below routes are part of phase 2 of this update

    // { title: 'ARTISTS', link: '/data/artists', selected: false  },
    // { title: 'TRACKS', link: '/data/tracks', selected: false  },
    // { title: 'GENRES', link: '/data/genres', selected: false  },
    // { title: 'SUBGENRES', link: '/data/subgenres', selected: false  }
  ];

  get route():string {
    return this._router.url;
  }

  constructor(private _router: Router) { }

  ngOnInit() {
    console.log("DataSideNavComponent init")
    this.updateNavItemsSelection();

  }

  updateNavItemsSelection() {
    this.navItems.forEach(item => {
      item.selected = this.route.includes(item.link);
    });
  }

  /**
   * Changes styling to show which tab is selected
   */
  changeTab(item: any){
    //set selected to false for all
    this.navItems = this.navItems.map(item => ({ ...item, selected: false }));

    const navItem = this.navItems.find(nav => nav.title === item.title);
    if (navItem) {
      navItem.selected = true;
    }
  }

}
